export * from './src/table-reservations-v1-time-slot-time-slots.meta.js';
